// Foundations
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

// Models
import { ReservationRequestItem } from 'src/app/models/reservation/reservation-request.model';


@Component({
  selector: 'app-reservation-dog-add-ons',
  templateUrl: './reservation-dog-add-ons.component.html',
  styleUrls: ['./reservation-dog-add-ons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReservationDogAddOnsComponent implements OnInit {

  // #region -> Property - Component IO <-
  // ----------

  @Input() formGroup: FormGroup;
  @Input() reservationRequest: ReservationRequestItem;
  @Input() useSpacing: boolean;

  @Output() selectedAddons = new EventEmitter<ReservationRequestItem>();

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Property <-
  // ----------

  get servicePetId(): string {
    return this.formGroup.get('id').value;
  }

  get serviceFormArray(): FormArray {
    return this.formGroup.get('serviceFormArray') as FormArray;
  }

  // Capture the error message of the input, key'd by "service element index"
  inputErrorMessages = {};

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Constructor <-
  // ----------

  constructor() {}

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Lifecycle <-
  // ----------

  ngOnInit(): void {}

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Method - UI <-
  // ----------

  toggleService(index: number): void {
    // set inputErrorMessages to ''
    this.inputErrorMessages[index] = '';
    //
    const element = this.serviceFormArray.at(index);

    if (element.value.isSelected) {
      // About to de-select
      this.reservationRequest = this.reservationRequest.removeAddonService(
        this.servicePetId,
        element.value.linkedService
      );
    } else {
      // Add the service to "reservation request"
      this.reservationRequest = this.reservationRequest.addNewAddonService(
        this.servicePetId,
        element.value.linkedService
      );
    }

    // Update the value
    element.patchValue({
      isSelected: !element.value.isSelected,
      //reset quantity to 1
      quantity: 1
    });

    // Updates
    this.selectedAddons.emit(this.reservationRequest);
  }

  changeQuantity(event, index: number): void {
    // Just update the value to "reservation request".
    // For the final error check, it can be done later.
    const newValue = +event.target.value;
    const element = this.serviceFormArray.at(index).value;
    this.inputErrorMessages[index] = '';
    if (Number.isNaN(newValue) || !Number.isInteger(newValue) || newValue < 1) {
      this.inputErrorMessages[index] = 'Please enter amount (1 - 99).'
    } else if (newValue > 99) {
      this.inputErrorMessages[index] = 'Maximum Quantity is 99.'
    }
    //
    this.reservationRequest = this.reservationRequest.addQuantity(
      this.servicePetId,
      element.linkedService.serviceId,
      newValue
    );

    // Updates
    this.selectedAddons.emit(this.reservationRequest);
  }

  canBeSelectable(index: number): boolean {
    //
    const element = this.serviceFormArray.at(index).value;
    if (element) {
      return this.reservationRequest.canBeSelectable(
        element.id,
        element.linkedService
      );
    }

    //
    return true;
  }

  // ----------
  // #endregion

  /////////////////////////////

}
